import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\AddAssignedPersonController::__invoke
* @see app/Http/Controllers/Planning/AddAssignedPersonController.php
* @route '/api/planning/{event}/person'
*/
const AddAssignedPersonController = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddAssignedPersonController.url(args, options),
    method: 'post',
})

AddAssignedPersonController.definition = {
    methods: ["post"],
    url: '/api/planning/{event}/person',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Planning\AddAssignedPersonController::__invoke
* @see app/Http/Controllers/Planning/AddAssignedPersonController.php
* @route '/api/planning/{event}/person'
*/
AddAssignedPersonController.url = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return AddAssignedPersonController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\AddAssignedPersonController::__invoke
* @see app/Http/Controllers/Planning/AddAssignedPersonController.php
* @route '/api/planning/{event}/person'
*/
AddAssignedPersonController.post = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddAssignedPersonController.url(args, options),
    method: 'post',
})

export default AddAssignedPersonController